import React from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { getPathLanguage } from '../../../utils/params';
import { Subtract } from 'assets/images/web-isn';
import { useTranslation } from 'react-i18next';
// import { useParams } from 'react-router-dom';

const BreadcrumbPolicys = props => {
    const { t } = useTranslation();
    const pathLanguage = getPathLanguage(useLocation());
    // const {category} = useParams();

    return (
        <div className="section-block section-breadcrumb background-gray">
            <div className="container">
                <div className="row breadcrumb px-0 align-items-center">
                    <div className="col-12 col-md-6">
                        <div className="breadcrumb-item row">
                            <ul>
                                <li>
                                    <Link to={`${pathLanguage}`}>{t('for_owners.home')}</Link>
                                </li>
                                <li>
                                    <img className="mb-1" src={Subtract} alt="subtract" />
                                    <span className="active">{props.breadCrum}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BreadcrumbPolicys;
